<template>
    <div
        class="alert alert-danger"
        role="alert">
        <slot>
            {{ text }}
        </slot>
    </div>
</template>

<script>

export default {
    props: {
        text: String, // eslint-disable-line
    },
}
</script>

<style scoped src="@/sass/components/_client-suspended-banner.scss" lang="scss"></style>
